import HargaKubikasiKayuApi from './HargaKubikasiKayuApi';

export default HargaKubikasiKayuApi;
